let userAgent = '';

export const setUserAgent = (ua: string): string => {
  userAgent = ua;
  return userAgent;
};

export const getUserAgent = (): string => userAgent;
